"use client"

import { ApplicationEnvironmentMolecule } from "@/app/env/store"
import { CrossmintProvider } from "@crossmint/client-sdk-react-ui"
import { useMolecule } from "bunshi/react"
import type { ReactNode } from "react"

interface CrossmintAppProviderProps {
  children: ReactNode
}

/**
 * Global CrossmintProvider for the entire application.
 * This prevents multiple provider instances when multiple checkout modals exist on the same page.
 * According to Crossmint docs, this should be at the app root level.
 */
export function CrossmintAppProvider({ children }: CrossmintAppProviderProps) {
  const env = useMolecule(ApplicationEnvironmentMolecule)
  const clientApiKey = env.crossmintClientApiKey

  // If no API key, don't wrap with provider
  if (!clientApiKey) {
    return <>{children}</>
  }

  return <CrossmintProvider apiKey={clientApiKey}>{children}</CrossmintProvider>
}
